import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ResortDetail, ResortInventory } from '../../models/presentation.model';
import { ResortInformation } from './resort-information.model';
@Component({
    selector: 'resort-info',
    templateUrl: './resort-information.component.html',
    styleUrls: ['./resort-information.component.scss'],
    encapsulation: ViewEncapsulation.None,

})
export class ResortInformationComponent implements OnInit {
    @Input() info: ResortInformation;
    public resortRoomTitle: string = "Resort & Room";

    constructor() { }

    ngOnInit() {
        this.resortRoomTitle = "Your Resort" + (this.info.detail.isPreferred ? " & Room" : "");
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/resort-information/resort-information.component.ts